export default {
  conversations: [],
  conversation: null,
  messages: [],
  templates: [],
  pagination: {},
  sessionActive: false,
  sessionExpiresAt: null,
  loading: false
}
